/**
* Service CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Service CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'service-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.service-cta-splide' ).length ) {
        $( '.service-cta-splide' ).each( function( index, element ) {
          new Splide( element, {
            type: 'loop',
            perPage: 3,
            rewind: true,
            perMove: 1,
            gap: '2rem',
            pagination: false,
            breakpoints: {
              1269: {
                perPage: 3,
              },
              768: {
                perPage: 1,
              },
            },
          } ).mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'service-cta', COMPONENT );
} )( app );
